<template>
  <component
    :is="componentType"
    :category="category"
    :grouping="rowGrouping"
    :name="rowName"
    :show-thumbnail="true"
    :thumbnail-url="thumbnailUrl"
    @row-clicked="rowClick"
  />
</template>

<script>
import ICSListRow from '@components/groupings/list-rows/ics';
import GroupingQuizListRow from '@components/groupings/list-rows/quiz';

export default {
  name: 'GroupingListRow',
  components: { GroupingQuizListRow, ICSListRow },
  props: {
    card: {
      type: Object,
    },
    category: {
      type: Object,
    },
    grouping: {
      type: Object,
    },
  },
  computed: {
    componentType() {
      if (this.rowGrouping.groupingType === 'Quiz') {
        return 'GroupingQuizListRow';
      } else {
        return 'ICSListRow';
      }
    },
    rowGrouping() {
      if (this.card) {
        return this.$store.getters['groupings/all'][this.card.assetId];
      } else {
        return this.grouping;
      }
    },
    rowName() {
      if (this.card) {
        return this.card.title;
      } else {
        return this.grouping.name;
      }
    },
    thumbnailUrl() {
      if (this.card) {
        return this.$store.getters['attachments/get'][this.card.featuredImageId]?.smallThumbnail;
      }
    },
  },
  methods: {
    rowClick() {
      const param = this.card ? this.card : this.grouping;
      this.$emit('row-clicked', param);
    },
  },
};
</script>
